<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card
        class="overflow-hidden"
        card-background="danger"
        content-color="white"
      >
        <div slot="no-body">
          <div class="p-6 flex justify-between flex-row-reverse items-center">
            <small class="flex cursor-pointer"> </small>
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">
                {{ stats.total_high }}
              </h2>
              <span>Haute</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card
        class="overflow-hidden"
        card-background="warning"
        content-color="white"
      >
        <div slot="no-body">
          <div class="p-6 flex justify-between flex-row-reverse items-center">
            <small class="flex cursor-pointer"> </small>
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">
                {{ stats.total_medium }}
              </h2>
              <span>Moyenne</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card
        class="overflow-hidden"
        card-background="success"
        content-color="white"
      >
        <div slot="no-body">
          <div class="p-6 flex justify-between flex-row-reverse items-center">
            <small class="flex cursor-pointer"> </small>
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">
                {{ stats.total_low }}
              </h2>
              <span>Basse</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
      <vx-card
        class="overflow-hidden"
        card-background="primary"
        content-color="#fff"
      >
        <div slot="no-body">
          <div class="p-6 flex justify-between flex-row-reverse items-center">
            <small class="flex cursor-pointer"> </small>
            <div class="truncate">
              <h2 class="mb-1 font-bold text-white">{{ stats.total }}</h2>
              <span>Total</span>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "dashboard-stats-by-priority",
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style>
</style>
